// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"8b0017d1","121":"000867b2","153":"e4d9422a","163":"2047336d","251":"a57c10ef","276":"97db391e","420":"92b796d8","460":"649e2c7b","606":"f7830f47","693":"34d44055","767":"d54c8abf","848":"1543b7c0","916":"31f873b7"}[chunkId] + ".chunk.js";
};